import { put } from 'redux-saga/effects';
import EasyRedux from '../../../utils/EasyRedux';
import handleSagaError from '../../handleSagaError';

const key = 'BLOG/LIST';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetBlogPosts(
  client,
  { payload: { siteId, resolve, reject } }
) {
  try {
    const response = yield client.post('/merchant/blog/search', {
      data: { site: siteId },
    });
    yield put(actions.loadSuccess(response.result.blogList));
    resolve && resolve(response.result.blogList);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
